import {
  getTimepointExamReassignmentPreviewStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignPreviewGet,
  TimepointSubmissionStatus,
} from '@common/config/api/client'
import { useQuery } from '@tanstack/react-query'

export const useTimepointExamReassignemenPreview = (
  queryKey: string[],
  studyId: string | undefined,
  subjectId: string | undefined,
  timepointSubmissionId: string | undefined,
  timepoint_status?: TimepointSubmissionStatus,
) => {
  return useQuery({
    queryKey: [...queryKey, studyId, subjectId, timepointSubmissionId, timepoint_status],
    queryFn: () =>
      getTimepointExamReassignmentPreviewStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignPreviewGet(
        {
          path: { study_id: studyId!, subject_id: subjectId!, timepoint_submission_id: timepointSubmissionId! },
          query: {
            timepoint_status: timepoint_status,
          },
        },
      ),
    enabled: !!studyId && !!subjectId && !!timepointSubmissionId,
  })
}
